import { CalendarDays, CheckSquare, Mail, Phone, StickyNote } from 'lucide-react'
import { cn } from '@/lib/utils'

const ICONS = {
    Call: Phone,
    Email: Mail,
    Meeting: CalendarDays,
    Task: CheckSquare,
    Note: StickyNote
}

const TONES: Record<string, string> = {
    Call: 'text-(--tag-green-text)',
    Email: 'text-(--tag-blue-text)',
    Meeting: 'text-(--tag-purple-text)',
    Task: 'text-(--tag-amber-text)',
    Note: 'text-(--tag-neutral-text)'
}

interface ActivityIconProps {
    type: string
    className?: string
}

export default function ActivityIcon({ type, className }: ActivityIconProps) {
    const Icon = ICONS[type as keyof typeof ICONS] ?? StickyNote

    return (
        <span
            aria-hidden
            className={cn(
                'bg-muted flex size-7 shrink-0 items-center justify-center rounded-md shadow-[0px_0px_0px_1px_#232323]',
                TONES[type] ?? TONES.Note,
                className
            )}
        >
            <Icon className='size-3.5' />
        </span>
    )
}
